import { InsertTicketCommandProps } from "./Commands/InsertTicketCommand"
import { UpdateTicketCommandProps } from "./Commands/UpdateTicketCommand"
import { GetTicketsByFiltersDtoProps } from "./DTOs/GetTicketsByFiltersDto"

export function insertTickerAdapter(
  ticket: InsertTicketCommandProps
): InsertTicketCommandProps {
  return {
    categoria: {
      icono: ticket.categoria?.icono,
      nombre: ticket.categoria.nombre,
    },
    conceptos: ticket.conceptos?.map((concepto) => ({
      cantidad: concepto.cantidad,
      nombre: concepto.nombre,
      precio: concepto.precio,
    })),
    cuentasContables: {
      bancariaId: ticket.cuentasContables?.bancariaId,
      categoriaId: ticket.cuentasContables?.categoriaId,
    },
    empleadoId: ticket.empleadoId,
    empresaId: ticket.empresaId,
    fechaEmision: ticket.fechaEmision,
    fichero: {
      ficheroAsBase64: ticket.fichero?.ficheroAsBase64,
      tipo: ticket.fichero?.tipo,
    },
    nombre: ticket.nombre,
    numero: ticket.numero,
  }
}

export function getTicketsByFilterAdapter(
  ticket: GetTicketsByFiltersDtoProps
): GetTicketsByFiltersDtoProps {
  return {
    id: ticket.id,
    categoria: ticket.categoria,
    conciliacionBancaria: ticket.conciliacionBancaria,
    contacto: ticket.contacto,
    empleado: ticket.empleado,
    estadoAprobacion: ticket.estadoAprobacion,
    fechaEmision: ticket.fechaEmision,
    haSidoModificado: ticket?.haSidoModificado,
    importe: ticket.importe,
    nombre: ticket.nombre,
    numero: ticket.numero,
  }
}

export function updateTicketAdapter(
  ticket: UpdateTicketCommandProps
): UpdateTicketCommandProps {
  return {
    id: ticket.id,
    conceptos: ticket.conceptos?.map((concepto) => ({
      cantidad: concepto.cantidad,
      nombre: concepto.nombre,
      precio: concepto.precio,
    })),
    cuentasContables: {
      bancariaId: ticket.cuentasContables?.bancariaId,
      categoriaId: ticket.cuentasContables?.categoriaId,
    },
    empresaId: ticket.empresaId,
    fechaEmision: ticket.fechaEmision,
    fichero: {
      ficheroAsBase64: ticket.fichero.ficheroAsBase64,
      id: ticket.fichero.id,
    },
    nombre: ticket.nombre,
    numero: ticket.numero,
  }
}
